import { render, staticRenderFns } from "./TencentTrafficComponent.vue?vue&type=template&id=57aa6d7a"
import script from "./TencentTrafficComponent.vue?vue&type=script&lang=js"
export * from "./TencentTrafficComponent.vue?vue&type=script&lang=js"
import style0 from "./TencentTrafficComponent.vue?vue&type=style&index=0&id=57aa6d7a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports